import { Stack, Typography, useTheme } from '@mui/material'
import React from 'react'
import CustomDatePicker from './CustomDatePicker'

interface DateRangePickerProps {
    onSetDateTo: (dateTo: Date | null) => void
    onSetDateFrom: (dateFrom: Date | null) => void
    dateTo: Date | null
    dateFrom: Date | null
    labelTo: string
    labelFrom: string
    /**
     * If true, the picker will have cross icon to cancel selection.
     * @default true
     */
    canBeCanceled?: boolean
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
    onSetDateFrom,
    onSetDateTo,
    dateFrom,
    dateTo,
    labelFrom,
    labelTo,
    canBeCanceled = true,
}: DateRangePickerProps) => {
    const theme = useTheme()

    return (
        <Stack
            spacing={theme.spacing(2)}
            pt={theme.spacing(2)}
            direction='row'
            style={{ maxWidth: 350, minWidth: 220 }}
            overflow='hidden'
        >
            <CustomDatePicker
                label={labelFrom}
                value={dateFrom}
                canBeCanceled={canBeCanceled}
                onChange={(newValue: Date | null) => {
                    newValue?.setHours(0, 0, 0, 0)
                    onSetDateFrom(newValue)
                }}
            />
            <Typography variant='subtitle1' pt={1}>
                -
            </Typography>
            <CustomDatePicker
                label={labelTo}
                value={dateTo}
                canBeCanceled={canBeCanceled}
                onChange={(newValue: Date | null) => {
                    newValue?.setHours(23, 59, 59, 999)
                    onSetDateTo(newValue)
                }}
            />
        </Stack>
    )
}

export default DateRangePicker
